const common = {
  'app.name': 'ShiftHub',
  'app.tagline': 'Time tracking system',
  'lang.label': 'Language',
  'lang.de': 'German',
  'lang.en': 'English',

  'nav.dashboard': 'Dashboard',
  'nav.times': 'Time tracking',
  'nav.month': 'Monthly overview',
  'nav.year': 'Yearly overview',
  'nav.alltime': 'Overall overview',
  'nav.vacation': 'Vacation',
  'nav.absences': 'Absences',
  'nav.calendar': 'Calendar',
  'nav.employees': 'Employees',
  'nav.teams': 'Teams',
  'nav.admin': 'Admin',
  'nav.adminUsers': 'User management',
  'nav.adminRoles': 'Roles & permissions',
  'nav.adminSchedules': 'Work schedules',
  'nav.adminTeam': 'Team overview',
  'nav.adminTeams': 'Manage teams',
  'nav.adminOverview': 'Overview',
  'nav.logout': 'Log out',

  'login.personnelNumber': 'Personnel number',
  'login.personnelNumberPlaceholder': 'e.g. 0001',
  'login.password': 'Password',
  'login.submit': 'Log in',
  'login.failed': 'Login failed',
  'login.greeting': 'Hello, {name}!',
  'login.whatToDo': 'What would you like to do?',
  'login.checkInOffice': 'Office – Clock in',
  'login.checkInHome': 'Home office – Clock in',
  'login.checkOut': 'Clock out',
  'login.toOverview': 'Go to overview',
  'login.checkInError': 'Error clocking in',
  'login.checkOutError': 'Error clocking out',
};

export default common;
